export enum AppRoutes {
  assessmentInventory = '/log/assessments',
  assessmentCompare = '/log/assessment/compare',
  governanceEvaluationInventory = '/log/governance-evaluations',
  dashboard = '/dashboard',
  login = '/login/',
  modelsInventory = '/inventory/models',
  modelDetails = '/inventory/models',
  usecasesInventory = '/inventory/usecases',
  log = '/log',
  incident = '/log/incident',
  docs = '/docs',
  settings = '/settings',
  dataCollection = '/questionnaire/data-collection',
  governanceEvaluation = '/questionnaire/governance-evaluation',
  aiModel = '/inventory',
  aiModelAdd = '/inventory/models/create',
  aiModelUpdate = '/inventory/models/update/',
  useCaseAdd = '/inventory/usecases/create',
  useCaseUpdate = '/inventory/usecases/update',
  useCaseDetails = '/inventory/usecases',
  incidentLog = '/log/incident',
  addIncident = '/log/incident/create',
  updateIncident = '/log/incident/update/',
  userProfile = '/userProfile',
  datasetInventory = '/inventory/datasets',
  datasetInventoryAdd = '/inventory/datasets/create',
  lifecycle = '/lifecycle',
}
